import React, { useReducer } from "react";
import { AppDispatchContext, AppStateContext } from "./context";
import { appReducer } from "./reducer";
import { initialState } from "./state";

type Props = {
  children: React.ReactElement;
};

export const StoreContextWrapper: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppDispatchContext.Provider value={dispatch}>
      <AppStateContext.Provider value={state}>
        {children}
      </AppStateContext.Provider>
    </AppDispatchContext.Provider>
  );
};
